import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Fade, Chip } from "@material-ui/core";
import { 
  Home as HomeIcon, 
  ChevronRight as ChevronRightIcon,
  NavigateNext as NavigateNextIcon 
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  paper: {
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    borderRadius: 16,
    padding: theme.spacing(2, 3),
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    border: "1px solid rgba(7, 108, 216, 0.1)",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
      transform: "translateY(-2px)",
    },
  },
  breadcrumbs: {
    "& .MuiBreadcrumbs-separator": {
      color: "#076cd8",
      fontSize: "1.2rem",
      margin: theme.spacing(0, 1),
    },
  },
  link: {
    color: "#076cd8",
    fontSize: "0.95rem",
    fontWeight: 500,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "all 0.3s ease",
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      backgroundColor: "rgba(7, 108, 216, 0.08)",
      color: "#065bb0",
      textDecoration: "none",
      transform: "scale(1.02)",
      "&::after": {
        width: "100%",
      },
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: 0,
      height: 2,
      backgroundColor: "#076cd8",
      transition: "width 0.3s ease",
    },
  },
  activeLink: {
    color: "#333",
    backgroundColor: "rgba(7, 108, 216, 0.1)",
    fontWeight: 600,
    cursor: "default",
    "&:hover": {
      backgroundColor: "rgba(7, 108, 216, 0.1)",
      transform: "none",
      color: "#333",
    },
  },
  homeIcon: {
    fontSize: "1.1rem",
    color: "inherit",
  },
  chip: {
    background: "linear-gradient(45deg, #076cd8, #4a90e2)",
    color: "white",
    fontWeight: 600,
    fontSize: "0.85rem",
    height: 28,
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1.5),
    },
  },
  separator: {
    color: "#076cd8",
    fontSize: "1.1rem",
    opacity: 0.6,
    margin: theme.spacing(0, 0.5),
  },
}));



export default function BreadCrumbsNav(props) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const handleNavigation = (url, event) => {
    event.preventDefault();
    if (url && url !== location.pathname) {
      history.push(url);
    }
  };

  const isActivePage = (url) => {
    return location.pathname === url;
  };

  const getIcon = (title, index) => {
    if (index === 0 || title.toLowerCase().includes('home')) {
      return <HomeIcon className={classes.homeIcon} />;
    }
    return null;
  };

  return (
    <Fade in={true} timeout={600}>
      <Box className={classes.container}>
        <Paper elevation={0} className={classes.paper}>
          <Breadcrumbs 
            aria-label="breadcrumb" 
            separator={<NavigateNextIcon fontSize="small" />}
            className={classes.breadcrumbs}
          >
            {props.breadOptions &&
              props.breadOptions.map((opt, index) => {
                const isActive = isActivePage(opt?.url);
                const isLastItem = index === props.breadOptions.length - 1;
                
                if (isLastItem) {
                  return (
                    <Chip
                      key={opt.title}
                      label={opt.title}
                      className={classes.chip}
                      size="small"
                      icon={getIcon(opt.title, index)}
                    />
                  );
                }

                return (
                  <Link
                    key={opt.title}
                    onClick={(e) => handleNavigation(opt?.url, e)}
                    className={`${classes.link} ${isActive ? classes.activeLink : ''}`}
                    component="button"
                    variant="body2"
                  >
                    {getIcon(opt.title, index)}
                    {opt.title}
                  </Link>
                );
              })}
          </Breadcrumbs>
        </Paper>
      </Box>
    </Fade>
  );
}
